import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemServicoDetalharComponent } from './item-servico-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ItemServicoDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class ItemServicoDetalharRoutingModule { }
